/** @jsx jsx */
import React, { useState } from 'react';

import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { Storyblok } from '../../storyblok';
import { parseHTML } from '../../services/parseHTML';

interface AccordionProps {
    accordionItems: any[];
}

const AccordionItem = ({
    content,
    title,
}: {
    title: string;
    content: string;
}) => {
    const [expandedState, setExpandedState] = useState<boolean>(false);

    const handleToggleExpandedState = () => setExpandedState(!expandedState);

    return (
        <AccordionItem.Wrapper>
            <AccordionItem.Heading onClick={handleToggleExpandedState}>
                <span>{title}</span>
                <span>{expandedState ? '-' : '+'}</span>
            </AccordionItem.Heading>
            <AccordionItem.Content expandedState={expandedState}>
                {parseHTML(content, 'markdown')}
            </AccordionItem.Content>
        </AccordionItem.Wrapper>
    );
};
AccordionItem.Wrapper = styled.div`
    margin: 0 0 20px;
    background-color: #ffffff;
    box-shadow: 0px 5px 5px 0px rgb(0 0 0 / 20%);
`;
AccordionItem.Heading = styled.header`
    padding: 30px 20px;
    font-size: 22px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
AccordionItem.Content = styled.div<{ expandedState: boolean }>`
    padding: 0 20px 30px;
    display: ${(props) => (props.expandedState ? 'block' : 'none')};

    p:last-of-type {
        margin: 0;
    }
`;

export const Accordion = ({ accordionItems, ...props }: AccordionProps) => {
    if (!accordionItems || !accordionItems.length) return;

    return (
        <Accordion.Wrapper>
            {accordionItems.map((accordion) => {
                return (
                    <AccordionItem
                        key={accordion.title}
                        content={accordion.content}
                        title={accordion.title}
                    />
                );
            })}
        </Accordion.Wrapper>
    );
};
Accordion.Wrapper = styled.div``;
Accordion.Item = styled.div``;
